import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EidosUtilityService } from '@common/services/eidos-utility.service';
import { EidosBaseList } from '@common/models/eidos-base-list.model';
import { Observable, take } from 'rxjs';
import { EidosLogSeverity } from '@common/models/core-constant.model';
import { EidosLogService } from '@common/services/eidos-log.service';
import { EidosConfigService } from '@app/core/config/eidos-config.service';
import { EidosSecurityService } from '@app/core/services/eidos-security.service';
import { ModalRef } from '@app/core/services/core-modal.service';

@Component({
  selector: 'eidos-settings-dialog',
  styleUrls: [
    'eidos-settings-dialog.component.scss'
  ],
  templateUrl: 'eidos-settings-dialog.component.html'
})

export class EidosSettingsDialogComponent implements OnInit, OnDestroy {
  @Input() modalRef!: ModalRef;

  public form = new UntypedFormGroup({
    company: new UntypedFormControl('', Validators.required),
    organization: new UntypedFormControl('')
  });

  public availableCompanies$: Observable<Array<EidosBaseList>> = this.utility.getAvailableCompanies();

  public availableOrganizations$: Observable<Array<EidosBaseList>> = this.utility.getAvailableOrganizations();

  protected enableOrganization: boolean=false;

  constructor(
    private utility: EidosUtilityService
    , private eidosLogService: EidosLogService
    , private eidosConfigService: EidosConfigService
    , protected eidosSecurityService: EidosSecurityService
  ) {
  }

  ngOnInit(): void {
    let user = this.utility.getCurrentUser();
    this.form.get('company')?.setValue(user?.company);
    this.form.get('organization')?.setValue(user?.organization);
    this.eidosConfigService.currentConfig
      .pipe(take(1))
      .subscribe(config => this.enableOrganization = config.enableOrganization ?? false);
  }

  onCancelClick(): void {
    this.modalRef.close();
  }

  onSaveClick(): void {
    const company = this.form.get('company')?.value;
    const organization = this.form.get('organization')?.value;
    const language = this.utility.getCurrentUser()?.language;

    const payload = { companyCode: company, languageCode: language };
    this.eidosLogService.logDebug(EidosLogSeverity.Log, 'Eidos: update current settings:', payload);

    this.utility.updateCurrentSetting({ companyCode: company, languageCode: language, organizaionCode: organization }).subscribe(result => {
      if (result) {
        this.modalRef.close();
      } else {
        this.eidosLogService.logDebug(EidosLogSeverity.Log, 'Eidos: update current settings fail');
      }
    });
  }

  ngOnDestroy() {
  }
}
